import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FORM_ROW_MARGIN_BOTTOM } from 'DesignTokens';

export const FormContainer = styled(Box)<{ className?: string }>(({ className }) => ({
  padding: '1rem',
  className: `react-FormContainer ${className || ''}`.trim(),
}));

export const SectionHeader = styled(Typography)<{ className?: string }>(({ className }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: '0.5rem',
  className: `react-SectionHeader ${className || ''}`.trim(),
}));

interface StyledFieldRowProps {
  unrestrictedWidth?: boolean;
  stacked?: boolean;
  className?: string;
}

export const StyledFieldRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'unrestrictedWidth' && prop !== 'stacked',
})<StyledFieldRowProps>(({ className, unrestrictedWidth, stacked }) => ({
  display: 'flex',
  flexDirection: stacked ? 'column' : 'row',
  alignItems: stacked ? 'flex-start' : 'center',
  marginBottom: FORM_ROW_MARGIN_BOTTOM,
  width: unrestrictedWidth ? 'auto' : '100%',
  className: `react-StyledFieldRow ${className || ''}`.trim(),
}));

interface StyledLabelProps {
  unrestricted?: boolean;
  stacked?: boolean;
}

export const StyledLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'unrestricted' && prop !== 'stacked',
})<StyledLabelProps>(({ unrestricted, stacked }) => ({
  width: unrestricted || stacked ? undefined : '140px',
  fontWeight: 500,
  flexShrink: 0,
}));
